import { createSelector } from 'reselect';

import { prescriptionQuery } from './apiSlice';

const getPrescriptionState = prescriptionQuery.select();

export const getPrescriptionStatus = createSelector(getPrescriptionState, (state) => state.status);
